import type { LngLatLike } from 'mapbox-gl';
import type { MapRef } from 'react-map-gl/mapbox';
import { defaultFlyToOptions, defaultPointZoom } from './constants';

/** Flies to a single point, such as a searched place or the current location, with the shared animation and zoom */
const flyToPoint = (map: MapRef, center: LngLatLike, eventData?: Parameters<MapRef['flyTo']>[1]) => {
  map.flyTo({ ...defaultFlyToOptions, center, zoom: defaultPointZoom }, eventData);
};

export default flyToPoint;
